/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAttendanceLogResponse } from './GetAttendanceLogResponse';
import {
    GetAttendanceLogResponseFromJSON,
    GetAttendanceLogResponseFromJSONTyped,
    GetAttendanceLogResponseToJSON,
    GetAttendanceLogResponseToJSONTyped,
} from './GetAttendanceLogResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetAttendanceLogResponse
 */
export interface PaginatedResultOfGetAttendanceLogResponse {
    /**
     * 
     * @type {Array<GetAttendanceLogResponse>}
     * @memberof PaginatedResultOfGetAttendanceLogResponse
     */
    items?: Array<GetAttendanceLogResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetAttendanceLogResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAttendanceLogResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAttendanceLogResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAttendanceLogResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAttendanceLogResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAttendanceLogResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetAttendanceLogResponse interface.
 */
export function instanceOfPaginatedResultOfGetAttendanceLogResponse(value: object): value is PaginatedResultOfGetAttendanceLogResponse {
    return true;
}

export function PaginatedResultOfGetAttendanceLogResponseFromJSON(json: any): PaginatedResultOfGetAttendanceLogResponse {
    return PaginatedResultOfGetAttendanceLogResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetAttendanceLogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetAttendanceLogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetAttendanceLogResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetAttendanceLogResponseToJSON(json: any): PaginatedResultOfGetAttendanceLogResponse {
    return PaginatedResultOfGetAttendanceLogResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetAttendanceLogResponseToJSONTyped(value?: PaginatedResultOfGetAttendanceLogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetAttendanceLogResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

